import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useCallback, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Collection from './Collection';
import Core from './Core';
import Customs from './Customs';
import Delivery from './Delivery';
import Loading from './Loading';
import Payment from './Payment';

const SalesOrderForm = forwardRef(({order, fields = 'core', onSaved, purchaseOrder = null}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  const getFields = useCallback(() => {
    switch (fields) {
      case 'loading':
        return Loading;
      case 'delivery':
        return Delivery;
      case 'collection':
        return Collection;
      case 'customs':
        return Customs;
      case 'payment':
        return Payment;
      case 'core':
      default:
        return Core;
    }
  }, [fields]);

  return (
    <BaseForm
      ref={formRef}
      entity={order}
      type="order"
      fieldsComponent={useCallback((props) => {
        const Fields = getFields();
        return <Fields {...props}/>
      }, [getFields])}
      onSave={useCallback((data) => (
        services.salesOrder.saveOrder({
          ...(order?.id ? {id: order.id} : {}),
          ...(purchaseOrder?.id ? {purchase_order_id: purchaseOrder.id} : {}),
          ...getFields().onSave(data)
        })
      ), [order, services, getFields, purchaseOrder])}
      onSaved={onSaved}
    />
  );
});

export default SalesOrderForm;
